export default __webpack_public_path__ + "static/media/papadums.8a81fd3f.png";